module.exports = __webpack_public_path__ + "img/icon_e53.b4602ffc.png";